import { IconProps } from './IconProps';

export const Lock = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="uis:lock">
        <path
          id="Vector"
          d="M11.3327 5.99967V4.66634C11.3327 2.79967 9.86602 1.33301 7.99935 1.33301C6.13268 1.33301 4.66602 2.79967 4.66602 4.66634V5.99967C3.53268 5.99967 2.66602 6.86634 2.66602 7.99967V12.6663C2.66602 13.7997 3.53268 14.6663 4.66602 14.6663H11.3327C12.466 14.6663 13.3327 13.7997 13.3327 12.6663V7.99967C13.3327 6.86634 12.466 5.99967 11.3327 5.99967ZM5.99935 4.66634C5.99935 3.53301 6.86602 2.66634 7.99935 2.66634C9.13268 2.66634 9.99935 3.53301 9.99935 4.66634V5.99967H5.99935V4.66634Z"
          fill={props.fill ?? '#ffffff'}
        />
      </g>
    </svg>
  );
};

